import jsonToUrl from '../component/common/jsonToUrl';
import * as cons from './cons';

export function getCardloanH5Url(param) {
	return jsonToUrl(cons.CARDLOAN_H5_LINK, param);
}

export function getCardloanH5LoginUrl(param) {
	return jsonToUrl(cons.CARDLOAN_H5_LINK, param) + '#!/login';
}

export function getCashloanH5Url(param) {
	return jsonToUrl(cons.CASHLOAN_H5_LINK, param);
}

export function getCashloanH5LoginUrl(param) {
	return jsonToUrl(cons.CASHLOAN_H5_LINK, param) + '#!/login';
}

export function getCardloanDownload(param) {
	return jsonToUrl(cons.KD_DOWNLOAD_LINK, param);
}

export function getEliteloanH5Url(param) {
  return jsonToUrl(cons.ELITELOAN_H5_LINK, param);
}

export function getEliteloanH5LoginUrl(param) {
  return jsonToUrl(cons.ELITELOAN_H5_LOGIN_LINK, param) + '#!/login';
}

export function getDownloadUrl(param) {
  return jsonToUrl(cons.NEW_DOWNLOAD_LINK, param);
}



// WEBPACK FOOTER //
// ./src/common/urlAddress.js